module.exports = __webpack_public_path__ + "media/effects-12.7f8cda88.webm";